import type { ValidationMessage } from 'gql/graphql';

import { downloadURI } from './downloadDataURI';

export type MapColumnsFn = (msg: Partial<ValidationMessage>, idx: number) => string;

const mapColumnsDefault: MapColumnsFn = (msg, idx) => `${idx}; ${msg?.message}`;

export const ExportCSVReport = (
    data: Partial<ValidationMessage>[] | null = [],
    customHeader = 'Номер; Сообщение',
    mapColumns: MapColumnsFn = mapColumnsDefault,
) => {
    const messages = data || [];
    const rows = messages.map(mapColumns).join('\n');

    const blobForExport = new Blob([`\uFEFF${customHeader}\n${rows}`], {
        endings: 'native',
        type: 'text/csv;charset=UTF-8',
    });

    // eslint-disable-next-line compat/compat
    downloadURI(window.URL.createObjectURL(blobForExport), `errorReport${new Date().getTime()}`);
};
